export default {
  datePickerContainer: {
    display: 'flex',
    padding: '10px 30px',
    alignItems: 'center',
    '& > h5': {
      color: '#546b81 !important',
      fontSize: '18px',
      '& + *': {
        marginLeft: '12px',
      },
    },
  },
  currentActiveBAs: {
    display: 'flex',
    color: '#546b81 !important',
    fontSize: '18px',
    marginLeft: '42px',
  },
  currentActiveBAsTab: {
    marginLeft: '5px',
  },
  dates: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '12px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  tablesContainer: {
    marginLeft: '16px',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    color: '#546b81 !important',
    fontSize: '18px',
    '& > div': {
      width: '94%',
      margin: '24px',
      height: 'fit-content',
    },
  },
}
